import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=277b3482&scoped=true"
import script from "./BillsList.vue?vue&type=script&lang=js"
export * from "./BillsList.vue?vue&type=script&lang=js"
import style0 from "./BillsList.vue?vue&type=style&index=0&id=277b3482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b3482",
  null
  
)

export default component.exports